import {useHref} from "react-router-dom";
import {useCallback} from "react";

/**
 * Custom hook that provides a function to programmatically reload a page relative to route paths.
 *
 * @param [to="/"] A route or path to navigate to for the reload. Defaults to the root path ("/").
 * @returns A callback function that, when invoked, reloads the page using the specified route.
 */
export const useReload = (to: string = "/") => {
  const href = useHref(to);

  return useCallback(() => {
    window.location.replace(href);
  }, [href]);
};